import React from 'react'
import { useTranslation } from 'react-i18next'

import { useMsal } from '@azure/msal-react'
import { Button } from 'primereact/button'

interface LoginButtonProps {
  isMaintenanceActive: boolean
}

const LoginButton: React.FC<LoginButtonProps> = ({
  isMaintenanceActive = true,
}) => {
  const { t } = useTranslation()
  const { instance } = useMsal()

  const handleLogin = (): void => {
    instance.loginRedirect()
  }

  return (
    <Button
      className="button p-button"
      style={{
        backgroundColor: '#0072BC',
        color: '#fff',
        borderRadius: '20px',
        border: '0px',
      }}
      label={t('common.auth.signIn')}
      disabled={isMaintenanceActive}
      onClick={handleLogin}
    />
  )
}

export default LoginButton
